import { useCallback, useEffect, useState } from 'react';
import { fetchNetworkMetrics } from '../api/networkMetrics';

const POLL_MS = 30_000;

function useSolanaMetrics(range = '30m') {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [latest, setLatest] = useState(null);

  const load = useCallback(async () => {
    try {
      const result = await fetchNetworkMetrics(range);
      setData(result.data);
      setLatest(result.latest);
      setError('');
    } catch (err) {
      setError(err?.message || 'Failed to load network metrics.');
    } finally {
      setLoading(false);
    }
  }, [range]);

  useEffect(() => {
    setLoading(true);
    setData([]);
    setError('');
  }, [range]);

  useEffect(() => {
    load();
    const intervalId = window.setInterval(load, POLL_MS);
    return () => window.clearInterval(intervalId);
  }, [load]);

  return { data, loading, error, latest, reload: load };
}

export default useSolanaMetrics;
